"use client";
import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import Skeleton from "react-loading-skeleton";

const PopUp = ({
  product,
  openProductId = null,
  setOpenProductId = null,
  popUp = null,
  setPopup = null,
  yesClick,
}) => {
  const isOpen = openProductId === product?.productId || Boolean(popUp);
  const [logoLoaded, setLogoLoaded] = useState(false);

  // reset logoLoaded when product changes
  useEffect(() => {
    setLogoLoaded(false);
  }, [product?.host?.image, product?.productId]);

  const handleClose = (e) => {
    // prevent parent handlers if called from button
    e?.stopPropagation?.();
    if (openProductId && typeof setOpenProductId === "function") {
      setOpenProductId(null);
    }
    if (typeof setPopup === "function") {
      setPopup(false);
    }
  };

  return (
    <div
      className={`${styles.popUpContainer} ${isOpen ? styles.showPopUp : ""} ${
        Boolean(popUp) && popUp === true ? styles.cursor : ""
      }`}
      onClick={() => {
        if (popUp) setPopup(false);
      }}
    >
      <p className={styles.hostLine}>
        To purchase this item, you will be redirected to
      </p>

      <div className={styles.hostDiv}>
        {product?.host?.image ? (
          <span className={styles.popUpLogo} aria-hidden>
            {!logoLoaded && (
              <Skeleton width={"40px"} height={"40px"} borderRadius={"50%"} />
            )}

            <img
              src={product.host.image}
              alt={`${product.host.name || "store"} logo`}
              onLoad={() => setLogoLoaded(true)}
              onError={() => setLogoLoaded(true)}
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                display: logoLoaded ? "block" : "none",
              }}
            />
          </span>
        ) : null}

        <span className={styles.hostName}>{product?.host?.name}</span>
      </div>

      <div className={styles.popUpActions}>
        <p>Proceed?</p>
        <div className={styles.popUpButtons}>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();

              yesClick?.(product);
            }}
          >
            Yes
          </button>

          <button type="button" onClick={handleClose}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
